module.exports = __webpack_public_path__ + "static/media/sinistreIconFaq.1c8a5a44.svg";